import { axios } from "../config";

export const getChatRules = () => {
  return axios.get("/api/v1/message/message/rules");
};

export const getNewChatList = (params) => {
  return axios.get("/api/v1/users/chat/participants", { params });
};

export const uploadDocuments = (data) => {
  return axios.post(`/api/v1/documents/upload`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const createNewsletter = (data) => {
  return axios.post(`/api/v1/communication/newsletter`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateNewsletter = (id, data) => {
  return axios.put(`/api/v1/communication/newsletter/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getNewsletter = () => {
  return axios.get("/api/v1/communication/newsletter");
};

export const getNewsletterById = (id) => {
  return axios.get(`/api/v1/communication/newsletter/${id}`);
};

export const deleteNewsletter = (id) => {
  return axios.delete(`/api/v1/communication/newsletter/${id}`);
};